<template>
  <div>
    <el-dialog title="添加楼盘" :visible.sync="showdialog" width="800px" v-dialogDrag @close="close">
      <div class="base-warp">
        <el-form :model="form" ref="form" :rules="rules" label-width="80px" :inline="false" size="normal">
          <el-form-item label="楼盘名称" prop="name">
            <el-input v-model="form.name" maxlength="30" placeholder="请输入30字以内的楼盘名称名称"></el-input>
          </el-form-item>
          <el-form-item label="楼盘地址" prop="address">
            <div class="input-box flex-box">
              <el-input class="input" v-model="form.address" placeholder="请输入楼盘地址"></el-input>
              <el-button type="primary" size="default" @click="loca">定位</el-button>
            </div>
            <div class="text-price"><span class="el-icon-s-opportunity"></span> 输入楼盘地址后点击后方定位，获取楼盘位置信息</div>
            <div class="address-info">
              <div class="text">经纬度： {{ location.lat }}, {{ location.lng }}</div>
              <div class="text">详细地址：</div>
            </div>
          </el-form-item>
          <el-form-item label="城市区域" prop="region">
            <el-cascader v-model="form.region" :options="regions" :props="{ label: 'label', value: 'label', children: 'children' }" @change="handleChange"> </el-cascader>
          </el-form-item>
          <el-form-item label="缩略图">
            <el-upload class="upload-demo" action="/api/Upload/uploadFile/" :on-success="handleAvatarSuccess" drag>
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过1M</div>
            </el-upload>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="confirm">添加</el-button>
            <el-button type="default" @click="showdialog = false">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      showdialog: true,
      form: {
        name: "",
        location: {},
        region: "",
        thumbnail: [],
        address: ""
      },
      headers: {},
      regions: [],
      token: this.$store.getters.gettoken,
      rules: {
        name: [
          { required: true, message: "请输入楼盘名称", trigger: "blur" },
          { min: 3, max: 30, message: "长度在 3 到 30 个字符", trigger: "blur" }
        ],
        region: [{ required: true, message: "请选择区域", trigger: "change" }],
        address: [{ required: true, message: "请输入地址", trigger: "blur" }]
      },
      imgs: [],
      location: {},
      managedCity: ""
    };
  },
  mounted() {
    this.getCityList();
    let managedCity = this.$store.getters.getuser.city;
    this.managedCity = managedCity;
  },
  methods: {
    getCityList() {
      this.$api.getCityList("").then((data) => {
        if (this.managedCity !== "全部") {
          data = data.filter((item) => {
            return item.label === this.managedCity;
          });
        }
        this.regions = data;
      });
    },
    handleChange() {},
    loca() {
      var address = this.form.address;
      if (!address) {
        this.$message.error("请先输入地址");
        return;
      }
      if (address.length < 8) {
        this.$message.error("请输入8个字以上的地址");
        return;
      }
      // var url = '/qqmap/ws/geocoder/v1/?address='+address+'&key=6IJBZ-KVSK4-XZJUM-DBSCR-MRQNV-C5FKW';
      var url = "/qqmap/ws/geocoder/v1/?address=" + address + "&key=BUGBZ-NR4KP-2AFDK-LJLEB-W2LVV-S5FGH";
      axios.get(url).then((res) => {
        let { data } = res;
        if (data.message != "query ok") {
          this.$message.error(data.message);
          return;
        }
        let result = data.result;
        let { location } = result;
        this.location = location;
        this.location.address = this.form.address;
      });
    },
    close() {
      this.$router.go(-1);
    },
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // if (!this.form.location){
          //     this.$message.error('请点击楼盘地址后面的定位获取位置信息');
          //     return;
          // }
          var region = this.form.region[1] + "-" + this.form.region[2];
          var params = {
            name: this.form.name,
            region,
            city: this.form.region[0],
            location: JSON.stringify(this.location),
            thumbnail: JSON.stringify(this.imgs)
          };
          this.$api.addProject(params).then((data) => {
            this.$message.success(data);
            this.showdialog = false;
          });
        } else {
          return false;
        }
      });
    },
    handleAvatarSuccess(e) {
      let { data, msg } = e;
      if (data) {
        this.$message.success(msg);
        this.imgs = data;
      } else {
        this.$message.error(msg);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #f7f7f7;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.flex-box {
  display: flex;
}
.input-box.flex-box {
  .input {
    margin-right: 20px;
  }
}
.text-price {
  color: #e6a23c;
  line-height: 20px;
}
.address-info {
  line-height: 20px;
  margin-top: 8px;
}
</style>
